import React, { useEffect } from "react";
import withIntl from "../utils/withIntl";
import CreatePos from "../components/Pos/CreatePos";
import cloudStore, { cloudStoreEvents } from "../store/CloudStore";
import PosForm from "../components/Pos/PosForm";
import Typography from "@material-ui/core/Typography";

function Pos(props) {
  const [merchant, setMerchant] = React.useState(cloudStore.merchant);

  const onChangeMerchant = () => {
    setMerchant({ ...cloudStore.merchant });
  };

  useEffect(() => {
    cloudStore.on(cloudStoreEvents.MERCHANT_UPDATED, onChangeMerchant);
    return () => cloudStore.removeListener(cloudStoreEvents.MERCHANT_UPDATED, onChangeMerchant);
  }, []);

  return (
    <div>
      <Typography gutterBottom variant="h5">
        {props.intl.formatMessage({ id: "pos_connection_settings" })}
      </Typography>
      {!merchant.merchantable_type && <CreatePos />}
      {["IKENTOO", "LIGHTSPEED", "TAURUS", "GASTROFIX", "MPLUS", "UNTILL"].includes(merchant.merchantable_type) ? (
        <PosForm posType={merchant.merchantable_type} />
      ) : (
        merchant.merchantable_type && (
          <>
            <Typography style={{ fontWeight: "600", display: "inlineBlock" }}>{merchant.merchantable_type}</Typography>
            <Typography>{props.intl.formatMessage({ id: "pos_connection_can_not_be_edited" })} </Typography>
          </>
        )
      )}
    </div>
  );
}

export default withIntl(Pos);
